import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SwUpdate } from '@angular/service-worker';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  public appPages = [
    { title: 'Inicio', url: '/home', icon: 'home' },
    { title: 'Quienes Somos', url: '/acerca', icon: 'call' },
    { title: 'Mapa', url: '/mapappal', icon: 'location' },
    { title: 'Organizaciones', url: '/explorar', icon: 'git-merge' },
    { title: 'Forma Parte', url: '/integrar', icon: 'add-circle' },
    { title: 'Biblioteca de Recursos', url: '/recursos', icon: 'list' },
    { title: 'Diario Mural', url: '/diariomural', icon: 'pin' },
    { title: 'Sesión', url: '/sesion', icon: 'key' },
    { 
      title: 'Comunidad', 
      url: '/comunidad',  
      icon: 'people',
      requiereAuth: true,
      tipoUsuario: 'organizacion'
    }
  ];

  constructor(
    public authService: AuthService,
    private router: Router,
    private swUpdate: SwUpdate,
    private cdr: ChangeDetectorRef
  ) 
  {

    if (this.swUpdate.isEnabled) {
    this.swUpdate.versionUpdates.subscribe(event => {
      if (event.type === 'VERSION_READY') {
        window.location.reload();
      }
    });
    // Chequear al iniciar
    this.swUpdate.checkForUpdate();

  }
  }

  ngOnInit() {
    // Actualizar menú cada vez que cambia la navegación
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.actualizarMenu();
    });
    
    this.actualizarMenu();
  }

  // Verificar si el usuario puede ver una página del menú
  puedeVerPagina(page: any): boolean {
    // Si no requiere autenticación, mostrar siempre
    if (!page.requiereAuth) {
      return true;
    }

    // Obtener usuario actual
    const usuario = this.authService.getUsuarioActual();

    // Si no hay usuario autenticado, no mostrar
    if (!usuario) {
      return false;
    }

    // Si requiere un tipo específico de usuario
    if (page.tipoUsuario) {
      return usuario.tipo === page.tipoUsuario;
    }

    // Si solo requiere estar autenticado (sin tipo específico)
    return true;
  }

  // Actualizar el estado del menú
  actualizarMenu() {
    // Forzar detección de cambios
    this.cdr.detectChanges();
  }

  // Método para cerrar sesión
  async cerrarSesion() {
    await this.authService.logout();
    this.actualizarMenu();
    this.router.navigate(['/home']);
  }

irAPerfil() {
  this.router.navigate(['/perfil']);
}

}